
import { Component, Vue } from "vue-property-decorator";
import routes from "@/router/routes.ko";
import ReviewProductSearchPop from "../biz/review/ReviewProductSearchPop.vue";
import FeedProductSearchPop from "../biz/feed/FeedProductSearchPop.vue";
import MainImgViewerPop from "../biz/main/MainImgViewerPop.vue";
import { LayoutDisplayItemOVO } from "../biz/main/vo/main.vo";
import MarketingReceiveAgreePop from "@/views/biz-kr/member/MarketingReceiveAgreePop.vue";
import DeliveryAddressChoicePop from '@/views/biz/order/DeliveryAddressChoicePop.vue';
import TermsPop1 from '@/views/biz-kr/member/TermsPop1.vue';
import TermsPop2 from '@/views/biz-kr/member/TermsPop2.vue';
import TermsPop3 from '@/views/biz-kr/member/TermsPop3.vue';
import TermsPop4 from '@/views/biz-kr/member/TermsPop4.vue';

@Component({ components: { ReviewProductSearchPop, FeedProductSearchPop, MainImgViewerPop, MarketingReceiveAgreePop, DeliveryAddressChoicePop,TermsPop1,TermsPop2,TermsPop3,TermsPop4 } })
export default class PublIndex extends Vue {
  showProductPop =false;
  showProductPop1 =false;
  mainImagePopOpened =false;
  showPop =false;
  showDeliveryAddressChoicePop =false;
  displayItems: Array<LayoutDisplayItemOVO> = [];
  showTerms1 = false;
  showTerms2 = false;
  showTerms3 = false;
  showTerms4 = false;

  // 라우터 경로
  get routerPaths() {
    const result = [] as Array<any>;
    routes.forEach((item) => {
      console.log(item);
      if (item.children && Array.isArray(item.children)) {
        item.children.forEach((item2) => {
          result.push(item2);
        });
        return;
      }
      result.push(item);
    });

    // variablesMap 안의 항목 치환
    result.forEach(item=>{
        this.variablesMap.forEach((map)=>{
            item.path = (item.path as string).replace(map.key, map.value);
        })
    })
    return result;
  }

  get variablesMap() {
      const result = [] as Array<{key: string; value: any}>;
      result.push({key: ":orderCd", value: 1000000940});
      result.push({key: ":productType", value: "02"});
      result.push({key: ":initMenuIdx", value: 1});
      result.push({key: ":layoutCd", value: 772});
      result.push({key: ":cateCd", value: 84});
      result.push({key: ":productCd", value: 179746});
      result.push({key: ":brandCd", value: 15});
      result.push({key: ":couponCd", value: 103});
      result.push({key: ":keyword", value: '이솝'});
      result.push({key: ":tab", value: 'all'});
      result.push({key: ":raffleProductCd", value: '60'});
      result.push({key: ":ugcCd", value: 13891});
      result.push({key: ":reviewCd", value: 13891});
      result.push({key: ":noticeCd", value: 60});
      result.push({key: ":targetMemCd", value: 5296});
      result.push({key: ":claimCd", value: 8587});

      return result;
  }
  created() {
    const displayItem = {} as LayoutDisplayItemOVO; 
    displayItem.seq = 259480;
    displayItem.fileUrl = "https://zikoo.s3.ap-northeast-2.amazonaws.com/main/202206/247504/197_main.jpg";
    displayItem.text = '<h1 style="color:#111; font-size: 25px;     line-height: 1.24;">산타마리아노벨라 할인전<br>전품목 최대 50% + 쿠폰증정 </h1> <span  style="color:#666; font-size: 14px; ">5% 쿠폰 다운받고 더 저렴하게 구매하세요!</span>';
    this.displayItems.push(displayItem);
    displayItem.seq = 259481;
    displayItem.fileUrl = "https://zikoo.s3.ap-northeast-2.amazonaws.com/main/202206/247504/197_main.jpg";
    displayItem.text = '<h1 style="color:#111; font-size: 25px;     line-height: 1.24;">산타마리아노벨라 할인전<br>전품목 최대 50% + 쿠폰증정 </h1> <span  style="color:#666; font-size: 14px; ">5% 쿠폰 다운받고 더 저렴하게 구매하세요!</span>';
    this.displayItems.push(displayItem);
  }
}
